import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Blogs from "./Blogs";
import { BlogType } from "../../types/types";
import { fetchBlogBySlug } from "../../service/service";
import { format } from "date-fns";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { AuthContext } from "../../context/AuthContext";

const BlogPost = () => {
  const { slug } = useParams<{ slug: string }>();
  const [blog, setBlog] = useState<BlogType | null>(null);
  const location = useLocation();
  const dataContext = useContext(AuthContext);

  useEffect(() => {
    const getBlog = async () => {
      try {
        const data = await fetchBlogBySlug(slug || "");
        setBlog(data.blogs as BlogType);
      } catch (error) {
        console.error("Error fetching blog:", error);
      }
    };

    if (location.state !== null) {
      setBlog(location?.state?.blog as BlogType);
    } else {
      getBlog();
    }
  }, [slug, location, location.pathname]);

  if (!blog) {
    return (
      <div className="w-full pt-28 mt-10 flex justify-center items-center">
        Blog not found.
      </div>
    );
  }
  let url = "https://admin.techqilla.com";

  const words = blog.title.trim().split(" ");
  const lastTwo = words.slice(-4).join(" ");
  const rest = words.slice(0, -4).join(" ");

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <>
      <div
        className={`${
          theme === "dark" ? "bg-white" : "bg-black"
        } transition-all duration-500 relative overflow-hidden sm:overflow-visible`}
      >
        <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28 h-[500px] sm:h-[400px]">
          <div className="flex flex-col items-center">
            <h1
              className={`${
                theme === "dark" ? "text-black" : "text-white"
              } transition-all duration-500 text-3xl sm:text-5xl text-center bricolage-grotesque-bold mt-44 sm:mt-14 sm:w-[60%]`}
            >
              {rest}{" "}
              <span className="text-gradient">
                {" "}
                {/* Change 'text-primary' to your desired color class */}
                {lastTwo}
              </span>
            </h1>
            <div className="flex justify-between items-center font-gtAmerica w-[80%] sm:w-[30%] mt-8">
              <div className="flex  sm:justify-center items-center gap-4 relative z-30">
                <img
                  src={`${url}${blog.techqilla_authors[0].image.url}`}
                  alt={blog.techqilla_authors[0].name}
                  className="size-8 rounded-full"
                />
                <p
                  className={`${
                    theme === "dark" ? "text-black" : "text-white"
                  } sm:text-lg font-gtAmerica font-semibold `}
                >
                  {blog.techqilla_authors
                    .map((author) => author.name)
                    .join(", ")}
                </p>
              </div>
              <p
                className={`${
                  theme === "dark" ? "text-black" : "text-white"
                } sm:text-lg font-gtAmerica font-semibold`}
              >
                {format(blog.createdAt, "MMM dd, yyyy")}
              </p>
            </div>
          </div>
        </div>
        <svg
        width="1444"
        height="1292"
        viewBox="0 0 1444 1292"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-[300px] sm:top-[80px] -left-[25%] sm:left-0 sm:right-0 sm:mx-auto h-full sm:h-auto w-[600px] sm:w-full"
      >
        <g filter="url(#filter0_f_3562_1617)">
          <ellipse cx="722" cy="646" rx="643" ry="393" fill="#8D19DA" />
        </g>
        <defs>
          <filter
            id="filter0_f_3562_1617"
            x="-173.6"
            y="0.399994"
            width="1791.2"
            height="1291.2"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="126.3"
              result="effect1_foregroundBlur_3562_1617"
            />
          </filter>
        </defs>
      </svg>
      <svg
        width="790"
        height="786"
        viewBox="0 0 790 786"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute mx-auto -left-[15%] sm:left-0 right-0 top-[430px] sm:top-[300px] h-full sm:h-auto w-[500px] sm:w-auto positive-animate-spin1"
      >
        <path
          d="M789.5 393C789.5 609.769 612.879 785.5 395 785.5C177.121 785.5 0.5 609.769 0.5 393C0.5 176.231 177.121 0.5 395 0.5C612.879 0.5 789.5 176.231 789.5 393Z"
          stroke="#727272"
        />
        <g filter="url(#filter0_f_3804_1744)">
          <circle cx="136" cy="95" r="9" fill="#F20B97" />
        </g>
        <defs>
          <filter
            id="filter0_f_3804_1744"
            x="113"
            y="72"
            width="46"
            height="46"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7"
              result="effect1_foregroundBlur_3804_1744"
            />
          </filter>
        </defs>
      </svg>
      </div>
      <div
        className={`${
          theme === "dark" ? "bg-white" : "bg-black"
        } sm:py-10 sm:px-10 transition-all duration-500`}
      >
        <div
          className={`${
            theme === "dark"
              ? " bg-white"
              : "sm:shadow-[0_0_20px_5px] sm:shadow-[#8D19DA] sm:bg-gradient"
          }  sm:p-4 relative z-10 sm:rounded-[16px] max-w-screen-2xl mx-auto transition-all duration-500`}
        >
          <div
            className={`${
              theme === "dark" ? "bg-white" : "bg-black"
            } w-full mx-auto relative sm:rounded-[16px] py-8 px-5 sm:py-0 sm:px-0`}
          >
            <img
              src={`${url}${blog.cover.url}`}
              alt="Blogimage"
              className="w-full rounded-[16px]"
            />
          </div>
        </div>
      </div>
      <div
        className={`${
          theme === "dark" ? "" : "bg-black text-white"
        } transition-all duration-500 `}
      >
        <div className="py-4 sm:py-10 px-4 sm:px-6 lg:px-20 font-gtAmerica max-w-screen-2xl mx-auto relative z-20">
          <Markdown rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
        </div>
      </div>
      <Blogs />
    </>
  );
};

export default BlogPost;
